import { createRef } from "react";

export const errorDetailsRef = createRef<{ show: (error: unknown) => void }>();

export function showErrorDetails(error: unknown): void {
  errorDetailsRef.current?.show(error);
}
